<div class="annotation-controls">
  <button
    appButton
    name="undo"
    location="annotation-controls"
    spacing="1"
    color="darker-blur"
    shape="round"
    height="1"
    (click)="onHistoryChange.emit('undo')"
    [iconButton]="true"
    appTooltip="Undo"
    tooltipKeyboardShortcut="Z"
    toolTipOrigin="right"
    [tooltipKeyboardShortcutMeta]="true"
    [class.disabled]="!canUndo"
  >
    <app-svg src="/assets/icons/undo-upside-down.svg"></app-svg>
  </button>
  @if (canRedo) {
    <button
      appButton
      name="redo"
      location="annotation-controls"
      spacing="1"
      [iconButton]="true"
      color="darker-blur"
      shape="round"
      height="1"
      (click)="onHistoryChange.emit('redo')"
      appTooltip="Redo"
      tooltipKeyboardShortcut="Y"
      [tooltipKeyboardShortcutMeta]="true"
    >
      <app-svg src="/assets/icons/redo.svg"></app-svg>
    </button>
  }

  @if (bigScreen()) {
    <div class="button-group">
      @for (_color of colors; track _color) {
        <button
          appButton
          name="{{ _color }}"
          location="annotation-controls"
          spacing="1"
          shape="round"
          [color]="color() === _color ? 'white' : 'darker-blur'"
          height="1"
          appTooltip="{{ _color | capitalize }}"
          [tooltipKeyboardShortcut]="shortcuts[_color]"
          (click)="switchColor(_color)"
        >
          <app-svg src="/assets/icons/status-{{ color() === _color ? 'active' : 'empty' }}.svg" [attr.color]="_color">
          </app-svg>
        </button>
      }
    </div>
    <div class="button-group">
      @for (_tool of tools; track _tool) {
        <button
          appButton
          name="{{ _tool }}"
          location="annotation-controls"
          spacing="1"
          shape="round"
          appTooltip="{{ _tool | annotationToolName }}"
          [tooltipKeyboardShortcut]="shortcuts[_tool]"
          [color]="tool() === _tool ? 'white' : 'darker-blur'"
          height="1"
          (click)="switchTool(_tool)"
        >
          <app-svg src="/assets/icons/annotate-{{ _tool }}.svg"></app-svg>
        </button>
      }
    </div>
  } @else {
    <div class="button-group">
      <app-context-menu [options]="{ width: '240px', noSpacing: true }" #colorMenu>
        <button
          appButton
          name="color-dropdown"
          location="annotation-controls"
          spacing="1"
          shape="round"
          color="darker-blur"
          height="1"
          contextButton
        >
          <app-svg src="/assets/icons/status-active.svg" [attr.color]="color()"></app-svg>
          <app-svg src="/assets/icons/24/arrow-down.svg" size="-0-5"></app-svg>
        </button>
        <div class="button-menu" contextContent>
          @for (_color of colors; track _color) {
            <app-button-menu-item
              name="{{ _color }}"
              location="annotation-controls"
              spacing="1-5"
              height="1"
              (click)="switchColor(_color); colorMenu.close()"
              [fullWidth]="true"
            >
              <app-svg
                src="/assets/icons/status-{{ color() === _color ? 'active' : 'empty' }}.svg"
                [attr.color]="_color"
              >
              </app-svg>
              <span>{{ _color | capitalize }}</span>
            </app-button-menu-item>
          }
        </div>
      </app-context-menu>
    </div>
    <div class="button-group">
      <app-context-menu [options]="{ width: '240px', noSpacing: true }" #toolMenu>
        <button
          appButton
          name="tool-dropdown"
          location="annotation-controls"
          spacing="2"
          shape="round"
          color="darker-blur-hard"
          height="1"
          weight="bold"
          [hasIcon]="true"
          contextButton
        >
          <app-svg src="/assets/icons/annotate-{{ tool() }}.svg"></app-svg>
          <span>{{ tool() | annotationToolName }}</span>
          <app-svg src="/assets/icons/24/arrow-down.svg" size="-0-5"></app-svg>
        </button>
        <div class="button-menu" contextContent>
          @for (_tool of tools; track _tool) {
            <app-button-menu-item
              name="{{ _tool }}"
              location="annotation-controls"
              spacing="1-5"
              height="1"
              (click)="switchTool(_tool); toolMenu.close()"
              [fullWidth]="true"
              [color]="tool() === _tool ? 'simple-primary' : 'simple'"
            >
              <app-svg src="/assets/icons/annotate-{{ _tool }}.svg"> </app-svg>
              <span>{{ _tool | annotationToolName }}</span>
            </app-button-menu-item>
          }
        </div>
      </app-context-menu>
    </div>
  }
  @if (!isDesktop) {
    <div class="button-group">
      <button
        appButton
        name="send"
        location="annotation-controls"
        color="primary"
        shape="round"
        height="1"
        spacing="3"
        (click)="done()"
        appTooltip="Send"
        [tooltipKeyboardShortcut]="'Enter'"
      >
        Next
      </button>
    </div>
  }
  <button
    appButton
    name="close"
    shape="round"
    location="annotation-controls"
    spacing="1"
    color="darker-blur"
    [iconButton]="true"
    height="1"
    (click)="onClose.emit()"
  >
    <app-svg src="/assets/icons/cross.svg"></app-svg>
  </button>
</div>
